// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1095":"4adfb075","1421":"4adfb075","2140":"06068062","2423":"ba36bd7c","3106":"06068062","4005":"ba36bd7c","6395":"ba36bd7c","6606":"06068062","7430":"ba36bd7c","9674":"4adfb075"}[chunkId] + ".chunk.css";
};